import { render } from "./ExaminationCounterView.vue?vue&type=template&id=ddfcd894&ts=true"
import script from "./ExaminationCounterView.vue?vue&type=script&lang=ts"
export * from "./ExaminationCounterView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__